import { Suspense } from 'react'
import { RouterProvider } from 'react-router/dom'
import LoadingPage from './components/LoadingPage'
import { router } from './data-router/router'

function App() {
  const loading = <LoadingPage fullscreen />
  return (
    <Suspense fallback={loading}>
      <RouterProvider router={router} />
    </Suspense>
  )
}

export default App
